import { cn } from "@/lib/utils";

export type KeyPointItem = {
  title: string;
  description: string;
};

type KeyPointsGridProps = {
  items: KeyPointItem[];
  className?: string;
};

export function KeyPointsGrid({ items, className }: KeyPointsGridProps) {
  return (
    <div
      className={cn(
        "grid gap-8 sm:grid-cols-2",
        className,
      )}
    >
      {items.map((item) => (
        <div key={item.title} className="flex flex-col gap-2">
          <h3 className="text-sm font-medium text-foreground">{item.title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
        </div>
      ))}
    </div>
  );
}
